import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getReferralList } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import "./ReferralList.css";

// MUI Icons
import PersonIcon from "@mui/icons-material/Person";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const ReferralList = () => {
  const [loading, setLoading] = useState(true);
  const [referrals, setReferrals] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 0,
    limit: 10,
  });
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const fetchReferrals = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page, limit: pagination.limit, search };
      const res = await getReferralList(params);
      setReferrals(res.data || []);
      setPagination(res.pagination || { page: 1, total: 0, limit: 10 });
    } catch (err) {
      console.error(err);
      if (err.status === 403) navigate("/unauthorized");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferrals();
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    // Optionally debounce or trigger on button click
  };

  const handlePageChange = (newPage) => {
    fetchReferrals(newPage);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="referral-list-container">
      <div className="list-header">
        <h2>Referrals</h2>
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by name or email..."
            value={search}
            onChange={handleSearch}
          />
          <button onClick={() => fetchReferrals(1)}>Search</button>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="table-wrapper">
            <table className="referral-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Referrer</th>
                  <th>Referred User</th>
                  <th>Date</th>
                  <th>Bonus</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {referrals.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="no-data">
                      No referrals found.
                    </td>
                  </tr>
                ) : (
                  referrals.map((ref, index) => (
                    <tr key={ref.id || index}>
                      <td>
                        {(pagination.page - 1) * pagination.limit + index + 1}
                      </td>
                      <td>
                        <div className="user-info">
                          <PersonIcon fontSize="small" />
                          <span>{ref.referrer?.fullName || "N/A"}</span>
                          <small>{ref.referrer?.email || ""}</small>
                        </div>
                      </td>
                      <td>
                        <div className="user-info">
                          <PersonIcon fontSize="small" />
                          <span>{ref.referredUser?.fullName || "N/A"}</span>
                          <small>{ref.referredUser?.email || ""}</small>
                        </div>
                      </td>
                      <td>
                        <DateRangeIcon fontSize="small" />
                        {formatDate(ref.createdAt)}
                      </td>
                      <td>
                        <AttachMoneyIcon fontSize="small" />
                        {ref.bonus || 0}
                      </td>
                      <td>
                        <span
                          className={`status-badge ${ref.status?.toLowerCase() || "pending"}`}
                        >
                          {ref.status || "Pending"}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          {pagination.total > pagination.limit && (
            <div className="pagination-controls">
              <button
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 1}
              >
                Previous
              </button>
              <span>
                Page {pagination.page} of{" "}
                {Math.ceil(pagination.total / pagination.limit)}
              </span>
              <button
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={
                  pagination.page >=
                  Math.ceil(pagination.total / pagination.limit)
                }
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReferralList;
